import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "./ChartCard"
import { MARGIN_COLORS, NIVO_THEME } from "./palette"

const MarginDistribution = ({ data }) => {
  const total = data.reduce((acc, d) => acc + d.value, 0)
  return (
    <ChartCard
      icon     = "chart-bar"
      title    = {I18n.t("chantiers_dashboard.charts.margin_distribution")}
      subtitle = {I18n.t("chantiers_dashboard.charts.margin_distribution_hint")}
      height   = {260}
      empty    = {total === 0 ? I18n.t("chantiers_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data            = {data}
        keys            = {["value"]}
        indexBy         = "label"
        margin          = {{ top: 18, right: 28, bottom: 42, left: 56 }}
        padding         = {0.32}
        colors          = {(d) => MARGIN_COLORS[d.indexValue] || "#94a3b8"}
        borderRadius    = {5}
        label           = {(d) => `${d.value}`}
        labelTextColor  = "#fff"
        labelSkipHeight = {14}
        axisBottom      = {{ tickSize: 4, tickPadding: 6 }}
        axisLeft        = {{ tickValues: 5 }}
        gridYValues     = {5}
        tooltip         = {({ value, indexValue }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "6px 10px", fontSize: 11, borderRadius: 6, boxShadow: "0 8px 20px rgba(15,23,42,0.25)" }}>
            <strong>{indexValue}</strong> · {value} {I18n.t("chantiers_dashboard.kpis.projects").toLowerCase()}
          </div>
        )}
        theme           = {NIVO_THEME}
      />
    </ChartCard>
  )
}

export default MarginDistribution
